<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-dynamic" :inline="true">
            <el-form-item label="批量价格" prop="BatchPrice" class="BatchPrice">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchPrice" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('price')">批量设置价格</el-button>
            </el-form-item>
            <el-form-item label="批量库存" prop="BatchInventory">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchInventory" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('stock')">批量设置库存</el-button>
            </el-form-item>
        </el-form>

        <div v-for="(item, index) of skuList" :key="index" class="gauge">
            <div class="left">{{ item.nameKv.kvName }}</div>

            <div class="valueKv">
                <div class="kvName" v-for="element of item.valueKvList">
                     <i class="el-icon-close close" @click="closekvName(element.kvName)"></i>
                    {{ element.kvName }}
                </div>
            </div>
        </div>

        <el-table :data="tableData" max-height="450px" border style="width: 100%" v-if="tableData.length != 0" size="small">
            <el-table-column
                v-for="(item, index) of skuList"
                :key="index"
                align="center"
                :prop="'kvName' + index"
                :label="item.nameKv.kvName"
            >
            </el-table-column>

            <el-table-column align="center" label="价格">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.price"
                        placeholder="请输入价格"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="库存">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.stock"
                        placeholder="请输入库存"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="图片">
                <template slot-scope="scope">
                    <el-upload
                        class="avatar-uploader"
                        style="width: 80px; height: 80px; text-align: center"
                        :data="scope.row"
                        :disabled="stateDisabled"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadSkuPicture"
                    >
                        <img v-if="scope.row.pic" :src="scope.row.pic" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun, upload } from '@/utils/request.js';

export default {
    data() {
        return {
            ruleForm: {
                BatchPrice: '',
                BatchInventory: '',
                Specifications: ''
            },
            Specifications: '',
            rules: {},
            skuList: [],
            skuValueList: [],
            brand: {},
            tableData: [],
            arrData: [],
            stateDisabled: false
        };
    },

    created() {
        eventBus.$on('pushSkuList', data => {
            this.skuList = data.base
            this.combination()
        })

        eventBus.$on('skuList', (data, value, state) => {
            this.skuList = data;
            this.skuValueList = value;
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }

            this.combination();
        });
    },
    beforeDestroy() {
        eventBus.$off('skuList');
    },
    methods: {
        closekvName(element) {
            loop: for (let item of this.skuList) {
                for (let i = 0; i < item.valueKvList.length; i++) {
                    if (item.valueKvList[i].kvName == element) {
                        item.valueKvList.splice(i, 1);
                        this.combination();
                        break loop;
                    }
                }
            }
            for (let i = 0; i < this.skuList.length; i++) {
                if (this.skuList[i].valueKvList == 0) {
                    eventBus.$emit('speckvName', this.skuList[i].kvName);
                    this.skuList.splice(i, 1);
                    if (this.skuList.length != 0) {
                        this.combination();
                    }
                    break;
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        combination() {
            let combine = function (skuList) {
                let res = [];
                let recursion = function (chunkIndex, prev) {
                    let skuValueList = skuList[chunkIndex].valueKvList;

                    let isLast = chunkIndex === skuList.length - 1;
                    for (let val of skuValueList) {
                        let temporary = prev.concat(val);
                        if (isLast) {
                            // 如果已经处理到数组的最后一项了 则把拼接的结果放入返回值中
                            res.push(temporary);
                        } else {
                            recursion(chunkIndex + 1, temporary);
                        }
                    }
                };
                // 从属性数组下标为 0 开始处理  // 并且此时的 prev 是个空数组
                recursion(0, []);
                return res;
            };
            let arr = combine(this.skuList);
            this.tableData = [];
            let j = 0;
            for (let item of arr) {
                let i = 0;
                let obj = {
                    skuKvIds: '',
                    skuKvNames: '',
                    skuCategory:'',
                };

                for (let element of item) {
                    let key1 = 'kvName' + i;
                    let key2 = 'price';
                    let key3 = 'stock';
                    let key4 = 'pic';
                    let key5 = 'id';
                    i++;
                    obj[key1] = element.kvName;
                    obj[key2] = '';
                    obj[key3] = '';
                    obj[key4] = '';
                    obj[key5] = j++;
                    obj.skuKvIds += element.kvId + ',';
                    obj.skuKvNames += element.kvName + ',';
                    obj.skuCategory = this.skuList.map((item)=>{return item.nameKv.kvName}).join(',');
                }
                if (obj.skuKvIds.length > 0) {
                    obj.skuKvIds = obj.skuKvIds.substr(0, obj.skuKvIds.length - 1);
                }
                if (obj.skuKvNames.length > 0) {
                    obj.skuKvNames = obj.skuKvNames.substr(0, obj.skuKvNames.length - 1);
                }
                if (obj.skuCategory.length > 0) {
                    obj.skuCategory = obj.skuCategory.substr(0, obj.skuCategory.length - 1);
                }
                obj.skuKvIds = this.ascending(obj.skuKvIds);
                obj.skuKvNames = this.ascending(obj.skuKvNames);
                obj.skuCategory = this.ascending(obj.skuCategory);
                this.tableData.push(obj);
                // break;
            }
            this.format();
        },
        format() {
            for (let item of this.tableData) {
                for (let element of this.skuValueList) {
                    if (item.skuKvIds == this.ascending(element.skuKvIds)) {
                        item.id = element.id;
                        item.pic = element.pic;
                        item.price = element.price;
                        item.stock = element.stock;
                        break;
                    }
                }
            }
        },
        // 升序排列
        ascending(value) {
            var array = new Array();
            array = value.split(',');
            // for (var element in array) {
            //     array[element] = parseInt(array[element]);
            // }
            array = array.sort(function (a, b) {
                return a - b;
            });
            return array.toString();
        },

        // 上传图片
        uploadSkuPicture(params) {
            const file = params.file;
            let product = params.data;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    for (let item of this.tableData) {
                        if (item.id == product.id) {
                            item.pic = res.url;
                        }
                    }
                }
            });
        },
        // 批量设置
        batchSetting(value) {
            if (this.tableData.length != 0) {
                for (let item of this.tableData) {
                    if (value == 'price') {
                        if (this.ruleForm.BatchPrice == '') {
                            this.$message({
                                message: '价格不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.price = this.ruleForm.BatchPrice;
                    }
                    if (value == 'stock') {
                        if (this.ruleForm.BatchInventory == '') {
                            this.$message({
                                message: '库存不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.stock = this.ruleForm.BatchInventory;
                    }
                }
                if (value == 'price') {
                    this.ruleForm.BatchPrice = '';
                }
                if (value == 'stock') {
                    this.ruleForm.BatchInventory = '';
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.input1 {
    margin-right: 15px;
}
.Specifications {
    padding-left: 100px;
    margin-bottom: 22px;
}
.input2 {
    width: 50%;
    margin: 10px 0;
}
::v-deep .el-input {
    width: 100px;
}
::v-deep .el-select {
    width: 100px;
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}

.gauge {
    color: #606266;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    .left {
        line-height: 32px;
        width: 58px;
        margin-right: 12px;
        text-align: right;
    }
}
.valueKv {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .kvName {
        padding: 0 10px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        margin: 0 10px 10px 0;
        position: relative;
    }
    .close {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background-color: #409eff;
        color: #fff;
        border-radius: 100%;
    }
}
.el-table {
    margin-bottom: 20px;
}

::v-deep .el-upload {
    width: 80px !important;
    height: 80px !important;
    text-align: center;
}
.avatar-uploader {
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
}
</style>
